/* Publish by EComposer at 2026-10-06 14:26:57*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tf2ao6adaa"]=  window.__ectimmers["ecom-tf2ao6adaa"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-tf2ao6adaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tf2ao6adaa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1n87bffq984').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1n87bffq984', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1lxhau4n628').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1lxhau4n628', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cadptrz7f8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cadptrz7f8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hup1oxbeji5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hup1oxbeji5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-87i2ixz15w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-87i2ixz15w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xu4axkncwcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xu4axkncwcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ogsb7thdf97').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ogsb7thdf97', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2cfktucmvdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cfktucmvdg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-now196ay0pg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-now196ay0pg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aqpip4mrqiu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aqpip4mrqiu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-178qzae3r93').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-178qzae3r93', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdjwro9hofs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdjwro9hofs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1qeirr2qyav').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1qeirr2qyav', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-35kbx8nt2g8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-35kbx8nt2g8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dneepa466vb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dneepa466vb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ee85fynsual').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ee85fynsual', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0a0pvp20z748').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0a0pvp20z748', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4vvl01b109').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4vvl01b109', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ubdn5kps1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ubdn5kps1r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nk9pdhj54hr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nk9pdhj54hr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mk9jjx9zmef').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mk9jjx9zmef', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htc9idhv409').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htc9idhv409', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s931a4w8xpr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s931a4w8xpr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q0e1gyxi79').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q0e1gyxi79', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n3wwjp6siog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n3wwjp6siog', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mkjycvscef').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mkjycvscef', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rgokyfcy468').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rgokyfcy468', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ksw3odzsgt"]=  window.__ectimmers["ecom-ksw3odzsgt"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-ksw3odzsgt"]["pepcozm9b"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ksw3odzsgt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ksw3odzsgt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8qcuz2vcb5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qcuz2vcb5k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ey2vwo1vk6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ey2vwo1vk6', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y39xjybpece"]=  window.__ectimmers["ecom-y39xjybpece"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-y39xjybpece"]["6gajzscgi"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-y39xjybpece').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y39xjybpece', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0lol8ectbqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0lol8ectbqw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nif2mocg9x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nif2mocg9x', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w5ak07v6t3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w5ak07v6t3n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4eb5zqd4ik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4eb5zqd4ik', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e5s124zep8d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5s124zep8d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kgytr6bjwt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kgytr6bjwt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k1aiyjsu89s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1aiyjsu89s', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93s0lueceok').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93s0lueceok', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6zyf6qqi4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6zyf6qqi4e', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8yv85cc1kho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8yv85cc1kho', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7mh0aijoz22').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7mh0aijoz22', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}